<template>
  <section class='layout-main'>
    <div style='height: 100%; background-color: #fff;' v-if='showTabs'>
      <el-tabs v-model='activeMenuCode' class='LayoutMain-tabs'
        type='card' v-if='openMenus.length > 0'
        style='background: #fff; height: 100%;'
        @tab-remove='tabRemove'>
        <el-tab-pane
          v-for='(menu) in openMenus'
          :key='menu.path.substring(1)'
          :closable='menu.path.substring(1) !== "index"'
          :label='menu.name'
          :name='menu.path.substring(1)'>
        </el-tab-pane>
        <keep-alive :include='this.$store.state.keepAlive'>
          <router-view style='padding: 3px 0px 0 0px;'/>
        </keep-alive>
      </el-tabs>
    </div>
    <div style='height: 100%; background-color: #fff;' v-else>
      <router-view style='padding: 3px 0px 0 0px;'/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LayoutMain',
  data: function () {
    return {
    }
  },
  computed: {
    activeMenuCode: {
      get: function () {
        return this.$store.state.activeMenuCode
      },
      set: function (val) {
        this.$store.dispatch('commitActiveMenuCode', val)
        let haveThisMenuName = false
        let thisMenuIndex = -1
        let thisMenuChildIndex = -1
        const userMenus = this.userMenus.concat([])
        userMenus.splice(0, 0, {
          Description: '主页',
          FilePath: 'index',
          Icon: 'sys sys-index',
          IsLeaf: '1',
          MenuCode: 'index',
          MenuLevel: 1,
          MenuName: '主页'
        })
        for (let i = 0; i < userMenus.length; i++) {
          if (userMenus[i].IsLeaf === '1') {
            if (userMenus[i].MenuCode.toUpperCase() === val.toUpperCase()) {
              thisMenuIndex = i
              break
            }
          } else {
            for (let j = 0; j < userMenus[i].Children.length; j++) {
              if (userMenus[i].Children[j].IsLeaf === '1') {
                if ((userMenus[i].Children[j].MenuCode).toUpperCase() === val.toUpperCase()) {
                  haveThisMenuName = true
                  thisMenuIndex = i
                  thisMenuChildIndex = j
                  break
                }
              }
            }
            if (haveThisMenuName) {
              break
            }
          }
        }
        if (thisMenuIndex >= 0 && thisMenuChildIndex < 0) {
          this.$router.push({ path: '/' + userMenus[thisMenuIndex].MenuCode, query: { parameterStr: userMenus[thisMenuIndex].Parameter } })
        } else if (thisMenuChildIndex >= 0) {
          this.$router.push({ path: '/' + userMenus[thisMenuIndex].Children[thisMenuChildIndex].MenuCode, query: { parameterStr: userMenus[thisMenuIndex].Children[thisMenuChildIndex].Parameter } })
        } else {
          this.$message.warning('菜单【' + val + '】不存在或您没有菜单【' + val + '】的权限！')
        }
      }
    },
    openMenus: function () {
      return this.$store.state.openMenus
    },
    showTabs: function () {
      return this.$store.state.showTabs
    },
    userMenus: function () {
      return this.$store.state.userMenus
    }
  },

  methods: {
    tabRemove: function (menuCode) {
      const that = this
      let deleteIndex = -1
      if (menuCode === this.activeMenuCode) {
        for (let i = 0; i < that.openMenus.length; i++) {
          if (that.openMenus[i].path.substring(1) === menuCode) {
            deleteIndex = i
            break
          }
        }
        that.$store.dispatch('commitDeleteOpenMenus', menuCode)
        if (deleteIndex > 0) {
          that.activeMenuCode = that.openMenus[deleteIndex - 1].path.substring(1)
          that.$router.replace({ path: that.openMenus[that.openMenus.length - 1].path, query: { parameterStr: that.openMenus[that.openMenus.length - 1].Parameter } })
        } else if (that.openMenus.length > 1) {
          that.activeMenuCode = that.openMenus[that.openMenus.length - 1].path.substring(1)
          that.$router.replace({ path: that.openMenus[that.openMenus.length - 1].path, query: { parameterStr: that.openMenus[that.openMenus.length - 1].Parameter } })
        } else {
          that.activeMenuCode = 'index'
          that.$router.replace({ path: '/index' })
        }
      } else {
        that.$store.dispatch('commitDeleteOpenMenus', menuCode)
      }
    }
  }
}
</script>

<style scoped>
.layout-main {
  height: calc(100vh - 80px);
  width: calc(100% - 30px);
  max-width: calc(100% - 30px);
  position: relative;
  overflow: auto;
  background: #fff;
  border-top: 1px solid #E4E7ED;
  padding: 6px 15px 3px 15px;
}
</style>

<style>
.LayoutMain-tabs .el-tabs__item {
  height: 28px;
  line-height: 28px;
}
.LayoutMain-tabs .el-tabs__header {
  margin: 0 0 5px;
}
.el-tabs__nav-prev {
  line-height: 28px !important;
}
.el-tabs__nav-next {
  line-height: 28px !important;
}
</style>
